import { createContext } from "react";

export interface StrengthIndicatorContext {
	strengthIndicator: string | null;
	setStrengthIndicator: (section: string) => void;
}

export const StrengthIndicatorContext = createContext<StrengthIndicatorContext>({
	strengthIndicator: null,
	setStrengthIndicator: () => {
		// to satisfy eslint
	},
});
